import { isWorkspaceByokRouteSelected } from '@affine/core/modules/ai-button/services/route-target';

import type { AIItemConfig } from '../components/ai-item/types';

export function isAIItemAvailableForRoute(
  item: Pick<AIItemConfig, 'requiresFydeOSByok'>,
  workspaceId: string
) {
  return (
    !item.requiresFydeOSByok ||
    isWorkspaceByokRouteSelected(workspaceId) === true
  );
}
